(function ($) {
    "use strict";

    $(function () {

        // Function to get form data (excluding file inputs)
        $.getFormData = function ($form) {
            const unindexedArray = $form.serializeArray();
            const indexedArray = {};

            $.map(unindexedArray, function (n) {
                if (!indexedArray[n['name']]) {
                    indexedArray[n['name']] = n['value'];
                } else {
                    indexedArray[n['name']] += ',' + n['value'];
                }
            });

            return indexedArray;
        };

        // Function to clear form errors
        const clearErrors = function ($element) {
            const $fieldItem = $element.closest('.js-field-item');
            $fieldItem.removeClass('has--error');
            $fieldItem.find('.js-error-text').html('');
        };

        // Event handlers for error clearing
        $(document).on('keydown', '.has--error input,.has--error textarea', function () {
            clearErrors($(this));
        });

        $(document).on('change', '.has--error select,.has--error input[type="checkbox"]', function () {
            clearErrors($(this));
        });

        // Email confirmation validation
        $(document).on('input', '.js-email-field, .js-email-confirm-field', function () {
            const $emailField = $('.js-email-field');
            const $emailConfirmField = $('.js-email-confirm-field');
            const $emailConfirmFieldItem = $emailConfirmField.closest('.js-field-item');
            
            if ($emailField.val() && $emailConfirmField.val()) {
                if ($emailField.val() !== $emailConfirmField.val()) {
                    $emailConfirmFieldItem.addClass('has--error');
                    $emailConfirmFieldItem.find('.js-error-text').html(`${localize.error_messages.email_not_match}`);
                } else {
                    $emailConfirmFieldItem.removeClass('has--error');
                    $emailConfirmFieldItem.find('.js-error-text').html('');
                }
            } else {
                $emailConfirmFieldItem.removeClass('has--error');
                $emailConfirmFieldItem.find('.js-error-text').html('');
            }
        });

        let blockTwice = false;
        $(".js-form-submit-button").prop("disabled", false);
        // General form submit handler (handles forms with and without file uploads)
        const handleSubmit = function (e, formAction, hasFileUpload = false) {
            e.preventDefault();
            const $form = $(this);
            let formData = hasFileUpload ? new FormData(this) : $.getFormData($form);

            if (blockTwice) return;

            blockTwice = true;
            $form.find(".js-form-submit-button").prop("disabled", true);

            const proceedWithSubmit = function (grecaptchatoken) {
                if (hasFileUpload) {
                    formData.append('grecaptchatoken', grecaptchatoken);
                    formData.append('action', formAction);
                    formData.append('nonce', localize.form_nonce);
                } else {
                    formData.grecaptchatoken = grecaptchatoken;
                    formData.action = formAction;
                    formData.nonce = localize.form_nonce;
                }

                $.ajax({
                    url: localize.ajaxurl,
                    type: 'POST',
                    data: hasFileUpload ? formData : {
                        action: formAction,
                        formData,
                        nonce: localize.form_nonce
                    },
                    processData: !hasFileUpload,
                    contentType: hasFileUpload ? false : 'application/x-www-form-urlencoded; charset=UTF-8',
                    success: function (data) {
                        blockTwice = false;
                        $form.find(".js-form-submit-button").prop("disabled", false);
                        const result = JSON.parse(data);
                        const fields = [...new Set(result['fields'])];
                        const errorMessages = result['error_messages'];

                        if (result['status'] === 'success') {
                            $form.addClass('form--success');
                            $('.form-response-message--success')[0].scrollIntoView({ behavior: "smooth", block: "center", inline: "nearest" });
                            $form.trigger('reset');
                            $('.js-char-current').text('0');
                            if (hasFileUpload) {
                                resetFileDisplay($form);
                            }
                        } else {
                            fields.forEach(function (fieldName) {
                                const $field = $form.find(`[name="${fieldName}"]`).closest('.js-field-item');
                                $field.addClass('has--error');
                                if (errorMessages[fieldName]) {
                                    $field.find('.js-error-text').html(errorMessages[fieldName].trim());
                                }
                            });
                        }
                    },
                    error: function () {
                        blockTwice = false;
                        alert('A szerver nem válaszol, próbálja újra később.');
                        $form.find(".js-form-submit-button").prop("disabled", false);
                    }
                }).done(function () {
                    blockTwice = false;
                    $form.find(".js-form-submit-button").prop("disabled", false);
                });
            };

            // Skip reCAPTCHA if kiosk mode is active and it's the newsletter form
            if (formAction === "newsletter_form" && localize.is_kiosk_mode) {
                proceedWithSubmit('');
            } else {
                grecaptcha.ready(function () {
                    grecaptcha.execute(localize.captcha_site_key, { action: 'submit' }).then(function (grecaptchatoken) {
                        proceedWithSubmit(grecaptchatoken);
                    });
                });
            }
        };


        // Attach event handlers to forms without file uploads
        $(".js-newsletter-form").on("submit", function (e) {
            handleSubmit.call(this, e, "newsletter_form", false);
        });

        $(".js-contact-form").on("submit", function (e) {
            handleSubmit.call(this, e, "contact_form", false);
        });

        $(".js-events-form").on("submit", function (e) {
            handleSubmit.call(this, e, "events_form", false);
        });

        $(".js-thematic-events-form").on("submit", function (e) {
            handleSubmit.call(this, e, "thematic_events_form", false);
        });


        // Attach event handler to PMT form (with file upload)
        $(".js-pmt-form").on("submit", function (e) {
            handleSubmit.call(this, e, "pmt_form_submission", true);
        });


        let token = new URLSearchParams(window.location.search).get("confirm_newsletter");
        let page_id = $(".js-page-id").val(); // Get the form ID from the hidden input field


        if (token && page_id) {

            $('.js-newsletter-form').addClass('loading');

            $.ajax({
                url: localize.ajaxurl,
                type: "POST",
                data: {
                    action: "confirm_newsletter_subscription",
                    token: token,
                    page_id: page_id
                },

                success: function (response) {
                    setTimeout(() => {
                        $('.js-newsletter-form').removeClass('loading');

                        $('.form-response-message__content p').text(response.data.message);
                        if (response.success) {
                            $('.js-newsletter-form').addClass('form--success');
                        } else {
                            $('.js-newsletter-form').addClass('form--error');
                        }
                    }, 1000);
                },

            });
        } else {
            $('.js-newsletter-form').removeClass('loading');
        }


        $('.js-back-to-form').on('click', function (e) {
            e.preventDefault();
            $('form.form--success').trigger('reset');
            $('form.form--success').removeClass('form--success')

        });


        // ======================
        // File Upload Handling
        // ======================
        const $fileInput = $('#file-input');
        const $uploadButton = $('.js-upload-btn');
        const $fileNameDisplay = $('#file-name-display');
        const $fileContainer = $('#uploaded-file-container');

        if ($fileInput.length && $uploadButton.length && $fileNameDisplay.length && $fileContainer.length) {

            // Trigger file input when upload button is clicked
            $uploadButton.on('click', function () {
                $fileInput.click();
            });

            // Display selected file name
            $fileInput.on('change', function () {
                if (this.files.length > 0) {
                    const fileName = this.files[0].name;
                    $fileNameDisplay.text(fileName);
                    $fileContainer.show();
                    const $fieldItem = $(this).closest('.js-field-item');
                    $fieldItem.removeClass('has--error');
                    $fieldItem.find('.js-error-text').html('');
                }
            });

            // Remove file from display and clear input
            $(document).on('click', '.js-delete-file', function () {
                $fileContainer.hide();
                $fileInput.val('');
                const $fieldItem = $(this).closest('.js-field-item');
                $fieldItem.removeClass('has--error');
                $fieldItem.find('.js-error-text').html('');
            });
        }

        // Reset file display after form reset
        const resetFileDisplay = function () {
            if ($fileContainer.length && $fileInput.length) {
                $fileContainer.hide();
                $fileInput.val('');
            }
        };

    });
})(jQuery);
